import { render } from "./TagBox.vue?vue&type=template&id=23b1592d&scoped=true"
import script from "./TagBox.vue?vue&type=script&lang=js"
export * from "./TagBox.vue?vue&type=script&lang=js"

import "./TagBox.vue?vue&type=style&index=0&id=23b1592d&scoped=true&lang=scss"
import "./TagBox.vue?vue&type=style&index=1&id=23b1592d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23b1592d"

export default script